<template>
  <section>
    
    <b-form>
      <b-form-input class="i-100" v-model="searchText" :placeholder="$t('SEARCH')"></b-form-input>
    </b-form>

    <div class="mt-2">
      <b-card no-body>

        <b-table stacked="md" :items="items" :fields="fields">

           <template v-slot:cell(name)="data">
             <router-link :to="{ name: 'Profile', params: { profileId: data.item.id }}">
              <b-media vertical-align="center" class="text-break">
                <template v-slot:aside>
                  <b-img
                    :src="profileImage(data.item)"
                    height="50"
                    alt="placeholder"
                  ></b-img>
                </template>
                <h5 class="mt-0 mb-0"><i class="fas fa-circle" v-bind:class="{ 'online': data.item.isOnline == 1, 'offline': data.item.isOnline == 0 }"></i> {{data.item.name}}</h5>
                <p class="mb-0">{{data.item.email}}</p>
              </b-media>
             </router-link>
          </template>
          
          <template v-slot:cell(state)="data">
            <span v-if="data.value==0">{{ $t('TEAM.ACTIVE') }}</span>
            <span v-if="data.value==1">{{ $t('TEAM.INACTIVE') }}</span>
          </template>

          <template v-slot:cell(isAdmin)="data">
            <i v-if="data.value==1" class="fal fa-check" />
            <i v-if="data.value==0" class="fal fa-times" />
            {{ showAdmin(data.value) }}
          </template>

         <template v-slot:cell(lastActivity)="data">
          {{ $moment(data.value) | moment("YYYY-MM-DD HH:mm") }}</template>
          <template v-slot:cell(id)="data">
            <edit-user :item="data.item" v-if="showEdit(data.item)" @updatedUser="updatedUser" :index="data.index">
              <b-button size="sm" class="float-right">
                {{ $t('TEAM.EDIT_USER')}}
              </b-button>
            </edit-user>
            
          </template>
        </b-table>
      </b-card>

      
     <b-pagination
     class="mt-2"
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="limit"
       align="center"
       @input ="getUsers"
    >
      <template v-slot:first-text>{{$t("PAGINATION.FIRST")}}</template>
      <template v-slot:prev-text>{{$t("PAGINATION.PREV")}}</template>
      <template v-slot:next-text>{{$t("PAGINATION.NEXT")}}</template>
      <template v-slot:last-text>{{$t("PAGINATION.LAST")}}</template>
    </b-pagination>


    </div>
  </section>
</template>
<script>
import EditUser from "@/components/Team/EditUser";
export default {
  components: {
    EditUser
  },
  data() {
    return {
      currentPage: 1,
      limit: 8,
      items: [],
      totalItems: 0,
      searchText: '',
      fields: [
        {
          key: "name",
          label: this.$t("TEAM.TABLE.NAME"),
          sortable: false
        },
        {
          key: "isAdmin",
          label: this.$t("TEAM.TABLE.ADMIN"),
          sortable: false
        },
        {
          key: "lastActivity",
          label: this.$t("TEAM.TABLE.LAST_LOGIN"),
          sortable: false
        },
        {
          key: "state",
          label: this.$t("TEAM.TABLE.STATUS"),
          sortable: false
        },
        {
          key: "id",
          label: "",
          sortable: false
        }
      ],
      user: this.$store.state.auth.user
    };
  },
  methods: {
    updatedUser: function(data) {
      this.$set(this.items, data.index, data.updatedInfo)
    },
    showState: function(state) {
      if (state === 0) {8
        return this.$t("TEAM.ACTIVE");
      }
      return this.$t("TEAM.INACTIVE");
    },
    showAdmin: function(isAdmin) {
      if (isAdmin === 1) {
        return this.$t("YES");
      }
      return this.$t("NO");
    },
    removeUser: function(id) {
      return id;
    },
    editUser: function(id) {
      return id;
    },
    profileImage(item) {
      if (item.imageExtension == null) {
        return "/img/default-avatar.png";
      } else {
        return process.env.VUE_APP_BACKEND + "/profile/image/" + item.id;
      }
    },
    getUsers: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/team/list", {
          page: this.currentPage,
          limit: this.limit,
          searchText: this.searchText
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
    showEdit(account) {      
      if(this.user.id == account.id)
      {
        return false;
      }
      if(this.user.superAdmin == 1)
      {
        return true;
      }
      if(this.user.isAdmin == 1)
      {
        return true;
      }
      return false;
    }
  },
  watch: {
    searchText: function() {
      if (this.searchText.length == 0) {
        this.getUsers();
      }
      if (this.searchText.length >= 3) {
        this.getUsers();
      }
    }
  },
  mounted: function() {
    this.getUsers();
  }
};
</script>
<style>
</style>